<script>
    import {http} from '../../http';
    import Calendar from '../calendar/Calendar.vue';


    export default {
        props: {
            open: {
                type: Boolean,
                default: false
            }
        },

        data: function () {
            return {
                last_clients_viewed: [],
                loaded: false
            }
        },

        methods: {
            showLastViewed() {
                if (!this.loaded) {
                    this.loaded = true;
                    http.get('/app/user-last-viewed/clients')
                        .then(({data}) => {
                            this.last_clients_viewed = data;
                        })
                        .catch(({error, errorBag}) => {
                            this.loaded = false;
                        });
                }
            }
        },

        components: {
            Calendar: Calendar
        },

        watch: {
            open: function (val) {
                if (val) {
                    this.showLastViewed();
                }
            }
        }
    }
</script>

<template>
    <template v-if="open">
        <nord-nav-group :heading="trans('global.recent_clients')" v-if="last_clients_viewed.length > 0" class="n-margin-is-l n-margin-be-s">
            <nord-nav-item
                v-for="client_viewed in last_clients_viewed"
                :key="client_viewed.id"
                :href="'/app/client/' + client_viewed.client.id"
            >
                <nord-stack direction="horizontal" align-items="center">
                    <div>
                        <nord-avatar :src="client_viewed.client.profile_image_url"></nord-avatar>
                    </div>

                    <nord-stack gap="none" class="clients-item-info">
                        <span class="name hovermenu-span">{{ client_viewed.client.name }}</span>
                        <span class="desc hovermenu-span">{{ client_viewed.client.email }}</span>
                    </nord-stack>
                </nord-stack>
            </nord-nav-item>
        </nord-nav-group>

        <div class="text-center" v-else>
            <div class="preloader"></div>
        </div>
    </template>
</template>

<style lang="scss" scoped>
.clients-item-info span.name {
    color: var(--n-color-text);
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 100%;
    overflow: hidden
}

.clients-item-info span.desc {
    color: var(--n-color-text-weaker);
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 100%;
    overflow: hidden;
    font-size: 12px
}
</style>